<template>
  <div id="app">
    <router-view v-if="isAlive" />
    <!-- <BackTop :height="100" :bottom="100"><div class="up"><i class="iconfont icon-shang"></i> <br> TOP</div></BackTop> -->
  </div>
</template>
<script>
import Head from "./components/pc/Head";
import Foot from "./components/pc/Foot";
import { BackTop } from "iview";
export default {
  name: "App",
  components: {
    Head,
    Foot,
    BackTop,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isAlive: true,
      hasHeadFoot: false,
    };
  },
  created() {},
  mounted() {
    //this.mobile();
  },

  watch: {
    $route: function (to, form) {
      //window.scrollTo(0,0)
    },
  },

  methods: {
    reload() {
      this.isAlive = false;
      this.$nextTick(() => {
        this.isAlive = true;
      });
    },
    // mobile() {
    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //     if((flag && flag.length) >0){
    //       this.$router.replace('/mobile'+this.$route.path)
    //     }
    // },
    headFoot() {
      if (this.$route.path.indexOf("mobile") != -1) {
        this.hasHeadFoot = false;
      } else if (this.$route.meta == "download") {
        this.hasHeadFoot = false;
      } else {
        this.hasHeadFoot = true;
      }
    },
  },
};
</script>

<style lang="less">
@import url("./assets/css/var.less");
body {
  height: 100%;
  overflow: auto;
}
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.up {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  color: #4da1ff;
  font-size: 18px;
  text-align: center;
  line-height: 22px;
  padding-top: 6px;
  i {
    color: #4da1ff !important;
    font-size: 12px !important;
    padding: 0 !important;
  }
}
</style>
